import { Controller } from "@hotwired/stimulus"

// Prefills the new-item form from a selected work item template. Labels and
// sub-items are applied server-side from template_id; here we prefill the
// visible fields (title, body, priority, assignees, estimate) for editing.
export default class extends Controller {
  static targets = ["select", "templateId", "title", "body", "priority", "assignee"]

  apply() {
    const option = this.selectTarget.selectedOptions[0]
    const id = this.selectTarget.value
    this.templateIdTarget.value = id
    if (!id) return

    const title = option.dataset.title || ""
    if (title && !this.titleTarget.value) this.titleTarget.value = title
    if (option.dataset.body && !this.bodyTarget.value) this.bodyTarget.value = option.dataset.body
    if (option.dataset.priority && this.hasPriorityTarget) this.priorityTarget.value = priorityName(option.dataset.priority)

    if (this.hasAssigneeTarget && option.dataset.assignees) {
      const ids = JSON.parse(option.dataset.assignees)
      if (ids.length) this.assigneeTarget.value = String(ids[0])
    }
  }
}

const PRIORITIES = ["none", "low", "medium", "high", "urgent"]
function priorityName(value) {
  // Templates store the integer enum value; the select uses enum names.
  const n = parseInt(value, 10)
  return Number.isNaN(n) ? value : (PRIORITIES[n] || "none")
}
